import { render, staticRenderFns } from "./oldindex.vue?vue&type=template&id=547624f3&scoped=true&"
import script from "./oldindex.vue?vue&type=script&lang=js&"
export * from "./oldindex.vue?vue&type=script&lang=js&"
import style0 from "./oldindex.vue?vue&type=style&index=0&id=547624f3&scoped=scoped&lang=css&"
import style1 from "./oldindex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547624f3",
  null
  
)

export default component.exports